import * as React from 'react';

import { StyledPageTitle, StyledSeparator } from './styles';
import FileFormat from '../FileFormat';
import { Api } from '../../../typings/api';

interface PageTitleProps {
	label: string;
	type: Api.AssetItemFileTypes;
	fileFormat: Api.AssetItemFileFormats;
	isProposal: boolean;
	isWide: boolean;
}

const PageTitle = ({ isWide, label, type, fileFormat, isProposal }: PageTitleProps) => (
	<StyledPageTitle
		isWide={isWide}
	>
		{label}
		<StyledSeparator>{'|'}</StyledSeparator>
		<FileFormat
			type={type}
			fileFormat={fileFormat}
			isProposal={isProposal}
		/>
	</StyledPageTitle>
);

export default PageTitle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PageTitle/index.tsx